import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { BlockValues, ComponentMeta } from "../BuilderUI.types";
import { DefaultEditorFieldsList } from "./DefaultEditorFieldsList";
import { DefaultEditorTabFields } from "./DefaultEditorTabFields";
import { useCategorizedBlockProps } from "./useCategorizedBlockProps";

export interface DefaultEditorProps {
  block: BaseBlock;
  meta: ComponentMeta;
  values: BlockValues;
}

export const DefaultEditor = ({ block, meta }: DefaultEditorProps) => {
  const { nestedGroups, tabOnlyGroups, unCategorizedProps, tabCategories } =
    useCategorizedBlockProps(block, meta);

  const hasOtherTabOnly =
    tabCategories.length === 1 && tabCategories[0] === "other";

  return (
    <div>
      {!hasOtherTabOnly && tabCategories.length > 0 && (
        <DefaultEditorTabFields
          block={block}
          tabCategories={tabCategories}
          nestedGroups={nestedGroups}
          tabOnlyGroups={tabOnlyGroups}
        />
      )}

      {hasOtherTabOnly && (
        <DefaultEditorFieldsList fields={tabOnlyGroups["other"]} />
      )}

      {unCategorizedProps.length > 0 && (
        <DefaultEditorFieldsList fields={unCategorizedProps} />
      )}
    </div>
  );
};
